import { isFinanceProject } from 'config';

import { RoleInCompany } from '../components';
import { useRoleInCompany } from '../hooks';
import { PageComponentProps } from '../types';

export const RoleInCompanyStep = ({ canGoBack }: PageComponentProps) => {
  const {
    files,
    initialValues,
    submitDisabled,
    submitLoading,
    onAddFiles,
    onRemoveFile,
    onSubmit,
    goToBack,
  } = useRoleInCompany();

  return (
    <RoleInCompany
      canGoBack={canGoBack}
      enabledCivilLawSubject={isFinanceProject()}
      files={files}
      initialValues={initialValues}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      onAddFiles={onAddFiles}
      onGoBack={goToBack}
      onRemoveFile={onRemoveFile}
      onSubmit={onSubmit}
    />
  );
};
